module.exports = function() {
  return new Worker(__webpack_public_path__ + "4fe108928ff87a6ed35f.worker.js");
};